var map = {
	"./Alex.png": 70984,
	"./Fausts.webp": 77161,
	"./Julia.png": 19129,
	"./Kris.png": 68327,
	"./LudLud.png": 94606,
	"./Ludwig.png": 77682,
	"./Masl.png": 55475,
	"./Michi.png": 10814,
	"./Moritz.png": 5437,
	"./Phil.png": 4575,
	"./Sarah.png": 78559,
	"./Steven.png": 58029,
	"./Toni.png": 85800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39624;